// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Jnp8","col":"styles_col__2z-5u","fulfillmentStatus":"styles_fulfillmentStatus__hq4vB","emailCol":"styles_emailCol__10oEn"};